import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Video: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm22 8-6 4 6 4V8Z' }],
    ['rect', { width: '14', height: '12', x: '2', y: '6', rx: '2', ry: '2' }],
  ],
];

export default Video;
